import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";

@Directive({
  selector: "[loadingSpinner]",
})
export class LoadingSpinnerDirective {
  private spinnerElement: HTMLElement | null = null;

  @Input() set loadingSpinner(loading: boolean) {
    loading ? this.addSpinner() : this.removeSpinner();
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  private addSpinner() {
    if (this.spinnerElement) return;

    this.spinnerElement = this.renderer.createElement("span");
    this.renderer.addClass(this.spinnerElement, "spinner-border");
    this.renderer.addClass(this.spinnerElement, "spinner-border-sm");
    this.renderer.setAttribute(this.spinnerElement, "role", "status");
    this.renderer.setAttribute(this.spinnerElement, "aria-hidden", "true");

    this.renderer.addClass(this.spinnerElement, "mr-1");

    this.renderer.insertBefore(
      this.el.nativeElement,
      this.spinnerElement,
      this.el.nativeElement.firstChild
    );
  }

  private removeSpinner() {
    if (this.spinnerElement) {
      this.renderer.removeChild(this.el.nativeElement, this.spinnerElement);
      this.spinnerElement = null;
    }
  }
}
